const API_URL = process.env.REACT_APP_API_URL;

export async function getCalendarEvents(startDate, endDate, userIds = []) {
  const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
  userIds.forEach((id) => params.append("user_ids[]", id));

  const response = await fetch(`${API_URL}/calendar/events?${params.toString()}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Erreur lors de la récupération des événements");
  return response.json();
}

export async function createDiary(data) {
  const response = await fetch(`${API_URL}/calendar/diary`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(data),
  });
  const json = await response.json();
  if (!response.ok || json.result === 0) throw new Error(json.message || "Erreur lors de la création");
  return json;
}

export async function getDiaryById(id) {
  const response = await fetch(`${API_URL}/calendar/diary/${id}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Erreur lors de la récupération de l'événement");
  return response.json();
}

export async function updateDiary(id, data) {
  const response = await fetch(`${API_URL}/calendar/diary/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(data),
  });
  const json = await response.json();
  if (!response.ok || json.result === 0) throw new Error(json.message || "Erreur lors de la modification");
  return json;
}

export async function deleteDiary(id) {
  const response = await fetch(`${API_URL}/calendar/diary/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  const json = await response.json();
  if (!response.ok || json.result === 0) throw new Error(json.message || "Erreur lors de la suppression");
  return json;
}
